export default __webpack_public_path__ + "static/media/Computer_Graph.6c1115f0.svg";